import styled from 'styled-components';

export const Container = styled.div`
    width: 674px ;
    // max-width: ;
    height: 138px;
    padding: 24px;
    border-radius: 10px;
    border: 1px solid var(--Gray-gray-100, #d4d6db);
    box-shadow: ${(props) => props.theme['card-shadow-2']};
    background: #fff;
    margin-bottom: 0;
    gap: 4px;

    .card-patrimonio {
        display: flex;
        flex-direction: column;
        justify-content: space-between;
        width: 100%;
        gap: 4px;
    }

    .card-patrimonio .top {
        display: flex;
        flex-direction: row;
        // justify-content: space-between;
        // gap: 24px;
    }

    .card-patrimonio .top > div {
        display: flex;
        flex-direction: column;
    }

    .card-patrimonio .title {
        color: var(--Gray-gray-700, #535862);

        /* Body/Small/Medium */
        font-family: Poppins;
        font-size: 14px;
        font-style: normal;
        font-weight: 500;
        line-height: 145%; /* 20.3px */
        margin-top: 0;
    }

    .card-patrimonio strong {
        align-self: stretch;

        color: var(--Gray-gray-800, #40444c);
        /* Heading/H5/SemiBold */
        font-family: Poppins;
        font-size: 24px;
        font-style: normal;
        font-weight: 600;
        line-height: 150%; /* 36px */
        margin-top: 0;
    }

    .card-patrimonio .divider-vertical {
        width: 1px;
        background: #eee;
        margin: 0 12px;
    }


    .card-patrimonio .bottom {
        display: flex;
        flex-direction: row;
        // justify-content: space-between;
        align-items: flex-start;
        gap: 0;

        width: auto;
        max-width: 400px;
        background-color: #ecf0f3;
        padding: 0.25rem 0.5rem;
        border-radius: 10px;
    }

    .bottom .image {
        display: flex;
        justify-content: center;
        align-items: center;
    }

    .bottom-left {
        display: flex;
        flex-direction: row;
        // gap: 4px;
    }

    .bottom-left .label {
        display: flex;
        justify-content: center;
        align-items: center;

        color: var(--Gray-gray-700, #535862);

        /* Body/Small/Medium */
        font-family: Poppins;
        font-size: 14px;
        font-style: normal;
        font-weight: 500;
        line-height: 145%; /* 20.3px */
        margin-top: 0;
    }

    .bottom-left .value {
        display: flex;
        justify-content: center;
        align-items: center;
        align-self: stretch;

        color: var(--Gray-gray-800, #40444c);
        /* Heading/H5/SemiBold */
        font-family: Poppins;
        font-size: 14px;
        font-style: normal;
        font-weight: 600;
        line-height: 150%; /* 36px */
        margin-top: 0;
    }

    .bottom-left .percentual {
        display: flex;
        justify-content: center;
        align-items: center;
        font-size: 14px;
        color: #EC6643;
    }

    .bottom .count {
        display: flex;
        justify-content: center;
        align-items: center;
        font-size: 14px;
        color: #40444c;
        white-space: nowrap;
    }
`;

export const Left = styled.div`
    display: flex;
    align-items: center;
    gap: 15.656px;
    flex: 1 0 0;

    img {
        width: 31.311px;
        height: 31.311px;
        aspect-ratio: 31.31/31.31;
    }

    strong {
        color: var(--Gray-gray-600, #6A717E);
        font-family: Poppins;
        font-size: 16px;
        font-style: normal;
        font-weight: 600;
        line-height: 143%; /* 22.88px */
        letter-spacing: 0.16px;
    }


`;

export const Right = styled.div`
    display: flex;
    flex-direction: column;
    align-items: center;
    flex: 1 0 0;

    strong {
        align-self: stretch;
        color: var(--Gray-gray-800, #40444C);
        font-family: Poppins;
        font-size: 24px;
        font-style: normal;
        font-weight: 600;
        line-height: 156%; /* 37.44px */
    }
    span {
        align-self: stretch;
        color: var(--Gray-gray-600, #6A717E);
        font-family: Poppins;
        font-size: 14px;
        font-style: normal;
        font-weight: 600;
        line-height: 143%; /* 20.02px */
        letter-spacing: 0.14px;
    }

    p{
        align-self: stretch;
        color: var(--Gray-gray-600, #6A717E);
        font-family: Poppins;
        font-size: 14px;
        font-style: normal;
        font-weight: 400;
        line-height: 143%; /* 20.02px */
        letter-spacing: 0.14px;
    }

`;
